import { UserInfo } from '../../../../shared/models/auth/user-info.model';
import { ASidebarBuilder } from './a-sidebar-builder';
import { Injectable } from '@angular/core';
import { SidebarMenuItem } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-item.model';
import { SidebarMenuContainer } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-container.model';

@Injectable()
export class PeSidebarBuilder extends ASidebarBuilder {
  protected rebuildProgramMenu(userInfo: UserInfo): void {
    const content = new Array<SidebarMenuItem | SidebarMenuContainer>();

    if (userInfo.CurrentProgramId !== null) {
      if (userInfo.IsTrainee && !userInfo.IsSiteAdmin && !userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            name: 'Dashboard',
            icon: 'arrow-to-right',
            style: { transform: 'rotate(180deg)' },
            isActive: this.routeHelper.dashboardActive.bind(this.routeHelper),
            action: this.routeHelper.dashboard.bind(this.routeHelper, userInfo.CurrentProgramRoleId)
          })
        );
      }

      if (!userInfo.IsTrainee || userInfo.IsSiteAdmin || userInfo.IsSysAdmin || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            name: 'Dashboard',
            icon: 'dashboard',
            isActive: this.routeHelper.performanceDashboardActive.bind(this.routeHelper),
            action: this.routeHelper.performanceDashboard.bind(this.routeHelper)
          })
        );
      }

      if (!userInfo.IsTrainee || userInfo.IsSiteAdmin || userInfo.IsSysAdmin || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            icon: 'users',
            name: 'Users',
            isActive: this.routeHelper.programUsersListActive.bind(this.routeHelper),
            action: this.routeHelper.programUsersList.bind(this.routeHelper)
          })
        );
      }

      if (userInfo.IsSysAdmin || userInfo.IsSiteAdmin || userInfo.IsCoordinator || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            icon: 'signal',
            name: 'Reports',
            isActive: this.routeHelper.peReportsActive.bind(this.routeHelper),
            action: this.routeHelper.peReports.bind(this.routeHelper)
          })
        );
      }

      content.push(
        new SidebarMenuItem({
          icon: 'file',
          name: 'Resources',
          isActive: this.routeHelper.resourcesActive.bind(this.routeHelper),
          action: this.routeHelper.resources.bind(this.routeHelper)
        })
      );

      content.push(
        new SidebarMenuItem({
          icon: 'search',
          name: 'Search',
          isActive: this.routeHelper.searchActive.bind(this.routeHelper),
          action: this.routeHelper.search.bind(this.routeHelper)
        })
      );
    }

    this.programMenuContent = content;
  }

  protected rebuildProgramSettingsMenu(
    userInfo: UserInfo,
    content: Array<SidebarMenuItem | SidebarMenuContainer>
  ): void {
    if (userInfo.IsSysAdmin || userInfo.IsSiteAdmin || userInfo.IsCoordinator) {
      const programSetupSubMenu = new SidebarMenuContainer({
        icon: 'tools',
        name: 'Program Settings'
      });

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Forms',
          isActive: this.routeHelper.peFormsActive.bind(this.routeHelper),
          action: this.routeHelper.peForms.bind(this.routeHelper)
        })
      );

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Incident Types',
          isActive: this.routeHelper.incidentTypesActive.bind(this.routeHelper),
          action: this.routeHelper.incidentTypes.bind(this.routeHelper)
        })
      );

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Corrective Actions',
          isActive: this.routeHelper.correctiveActionsActive.bind(this.routeHelper),
          action: this.routeHelper.correctiveActions.bind(this.routeHelper)
        })
      );

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Performance',
          isActive: this.routeHelper.performanceActive.bind(this.routeHelper),
          action: this.routeHelper.performanceCategories.bind(this.routeHelper)
        })
      );

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Alerts',
          isActive: this.routeHelper.alertsActive.bind(this.routeHelper),
          action: this.routeHelper.alerts.bind(this.routeHelper)
        })
      );

      content.push(programSetupSubMenu);
    }
  }
}
